<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import StellarBackground from '../animations/StellarBackground.vue'
import Button from '../ui/Button.vue'
import { useI18n } from 'vue-i18n'


const { t } = useI18n()

const discordInviteLink = "https://alterlan.be/discord"

let availableTickets = [
  {
    "pretixItemId": 526896,
    "name": {
      "en": "LAN ticket"
    },
    "available": 176,
    "total": 176,
    "unlimited": false
  },
  {
    "pretixItemId": 664357,
    "name": {
      "en": "Visitor ticket",
      "nl": "Bezoeker ticket"
    },
    "available": 50,
    "total": 50,
    "unlimited": false
  }
];


let lanTickets = computed(() => availableTickets.find(ticket =>  ticket.pretixItemId === 526896));
let visitorTickets = computed(() => availableTickets.find(ticket =>  ticket.pretixItemId === 664357));

const props = defineProps<{
  startAnimation: boolean
}>()

const subtitle = computed(() => t('homePage.heroSection.subtitle'));
const date = computed(() => t('homePage.heroSection.date'));

watch(() => props.startAnimation, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      document.querySelector('.hero-section')?.classList.add('fade-in')
    }, 10)
  }
})
</script>

<template>
  <section class="hero-section">
    <StellarBackground :start-animation="!props.startAnimation" />
    <div class="background-overlay"></div>
    <div class="content-container">
      <h1 class="title">
        ALTERLAN
      </h1>
      <h2 class="subtitle" v-html="subtitle"></h2>
      <div class="date-container">
        <img src="@/assets/icons/time_and_date.png" alt="Time and Date">
        <div class="date" v-html="date"></div>
      </div>
      <!-- <div class="tickets-info">
        <div class="ticket-count">
          <v-icon color="#76c4ae" size="small">mdi-ticket</v-icon>
          <span>{{ lanTickets?.available }} / {{ lanTickets?.total }} {{ t('homePage.heroSection.tickets.lan') }}</span>
        </div>
      </div> -->
      <div class="button-container">
          <Button size="x-large" filled icon-start="mdi-ticket" width="240px" href="https://alterlan.be/tickets?utm_source=alterlan&utm_medium=website&utm_content=get-tickets" target="_blank" rel="noopener noreferrer"> 
            {{ t('homePage.heroSection.ticketText') }}
          </Button>
        <Button class="" :href="discordInviteLink" target="_blank" rel="noopener noreferrer" icon-start="mdi-message-text" size="x-large" width="240px">
          {{ t('homePage.heroSection.more') }}
        </Button>
      </div>
      <v-row class="partners-row">
        <v-col cols="4" md="4">
          <div class="partner-container">
            <img class="partner-logo" src="@/assets/logos/TEAMSPEAK.png" alt="Partner Logo">
          </div>
        </v-col>
        <v-col cols="4" md="4">
        <div class="partner-container">
          <img  class="partner-logo" src="@/assets/logos/ALTERNATE.png" alt="Partner Logo">
        </div>
        </v-col>
        <v-col cols="4" md="4">
        <div class="partner-container">
          <img  class="partner-logo" src="@/assets/logos/SHARKOON.png" alt="Partner Logo">
        </div>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<style scoped>
.partner-logo {
  width: 100%;
  max-width: 200px;
  height: auto;
  margin: 0 0.1rem;
  z-index: 100;
}

.partner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.partners-row {
  margin-top: 1rem;
  transform: translateY(100px);
}

@media (max-height: 1000px) {
  .partners-row {
    transform: translateY(10px);
  }
}

@media (max-width: 768px) {
  .partners-row {
    transform: translateY(10px);
    margin-bottom: 2rem;
    padding: 0 1rem;
    width: 100%;
  }
}

.hero-section {
  position: relative;
  height: calc(100vh - 80px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden !important;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.5s ease-out;
}

.background-overlay {
  position: absolute;
  top: -350px;
  left: 0;
  width: 100%;
  height: calc(100% + 350px);
  background: radial-gradient(rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8), hwb(163 46% 23% / 0.5),  hwb(163 46% 23% / 0.6));
  z-index: 1;
  animation: overlayPulse 20s ease-in-out infinite;
}

@keyframes overlayPulse {
  0% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.2;
  }
}

.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.content-container {
  position: relative;
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  margin-top: 3rem;
}

.date-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  margin-top: -1%;
  margin-bottom: 1rem;

}

.date-container p {
  font-size: 1.3rem;
  font-weight: 200;
  font-style: thin;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.date-container img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
}

.title {
  font-family: 'Airborne GP', system-ui, sans-serif;
  font-size: 8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 2rem;
  line-height: 1.2;
  text-transform: uppercase;
  font-weight: normal;
}

.title-logo {
  width: 100%;
  max-width: 800px;
  height: auto;
  margin: 0 auto;
  display: block;
}

.subtitle {
  font-size: 2rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 3rem;
  line-height: 1.6;
  letter-spacing: 1px;
  text-align: center;
}

.date {
  font-size: 1.1rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.tickets-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0 1.5rem 0;
}

.ticket-count {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.5rem;
  font-weight: 600;
}

.button-container {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 1rem;
}

@media (max-width: 1150px) {
  .title {
    width: 90%;
    font-size: 6.5rem;
  }
  
  .subtitle {
    font-size: 1.8rem;
  }

}

@media (max-width: 768px) {
  .tickets-info {
    margin: 0.25rem 0 1rem 0;
  }
  
  .ticket-count {
    font-size: 0.9rem;
  }
}

@media (max-width: 850px) {
  .title {
    font-size: 4rem;
  }
  
  .subtitle {
    font-size: 1.2rem;
  }
  
  .button-container {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 550px) {
  .title {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1.2rem;
  }
  
  .button-container {
    flex-direction: column;
    gap: 1rem;
  }

  .hero-section {
    overflow-y: scroll;
  }
}
</style>
